"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentsPage = void 0;
const shipments_page_component_1 = require("./shipments-page/shipments-page.component");
Object.defineProperty(exports, "ShipmentsPage", { enumerable: true, get: function () { return shipments_page_component_1.ShipmentsPage; } });
